import {CELL_TYPE, COL_TYPE} from '../GelDragDrop.constants';

export function getStyle(table) {
  let repeatColumns = table.length;
  let template = `repeat(${repeatColumns}, 1fr)`;
  if (hasLabelColumn(table)) {
    repeatColumns = repeatColumns - 1;
    template = `72px repeat(${repeatColumns}, 1fr)`;
  }
  return {gridTemplateColumns: template};
}

function hasLabelColumn(table) {
  return table[0].colType === COL_TYPE.LABEL_COLUMN;
}

export function checkIfTrashMessageBright(gelTable) {
  return gelTable.reduce((isBright, column) => {
    if (column.colType === COL_TYPE.BAND_COLUMN) {
      let index = column.colItems.findIndex(
        (cell) => cell.cellType === CELL_TYPE.TRASH_CAN
      );
      if (isTrashNotEmpty(index, column)) {
        isBright = false;
      }
    }
    return isBright;
  }, true);
}

function isValidNumber(index) {
  return index !== null && index >= 0;
}

function isTrashNotEmpty(index, column) {
  return isValidNumber(index) && column.colItems[index].cellItems.length > 0;
}
